import 'fslightbox';

const LIGHTBOX_LINK_SELECTOR = 'a[data-fslightbox]';
const CUSTOM_CAPTION_CLASS = 'my-fslightbox-caption';

function cleanupInvalidHashTargets(root = document) {
    root.querySelectorAll(LIGHTBOX_LINK_SELECTOR).forEach((link) => {
        const href = link.getAttribute('href') || link.getAttribute('data-href') || '';

        if (!href.startsWith('#')) {
            return;
        }

        const targetId = href.slice(1);
        if (targetId && document.getElementById(targetId)) {
            return;
        }

        link.removeAttribute('data-fslightbox');
    });
}

function findLightboxContainer(element) {
    return element?.closest(
        '.fslightbox-full-dimension, .fslightbox-slide, .fslightbox-container'
    ) || null;
}

function upsertCaption() {
    const sources = document.querySelectorAll('.fslightbox-source[caption]');
    sources.forEach((source) => {
        const captionText = source.getAttribute('caption') || '';
        const container = findLightboxContainer(source);

        if (!container) {
            return;
        }

        let caption = container.querySelector(`.${CUSTOM_CAPTION_CLASS}`);

        if (!caption) {
            caption = document.createElement('div');
            caption.className = CUSTOM_CAPTION_CLASS;
            container.appendChild(caption);
        }

        if (caption.textContent !== captionText) {
            caption.textContent = captionText;
        }
        const expectedDisplay = captionText ? 'block' : 'none';
        if (caption.style.display !== expectedDisplay) {
            caption.style.display = expectedDisplay;
        }
    });
}

function removeOrphanCaptions() {
    document.querySelectorAll(`.${CUSTOM_CAPTION_CLASS}`).forEach((caption) => {
        const container = findLightboxContainer(caption);
        if (!container || !container.querySelector('.fslightbox-source[caption]')) {
            caption.remove();
        }
    });
}

function withDisabledObserver(fn) {
    const observer = window.__fsLightboxCaptionObserver;
    if (observer) {
        observer.disconnect();
    }
    try {
        fn();
    } finally {
        if (observer) {
            observer.observe(document.body, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['class', 'style', 'src', 'caption'],
            });
        }
    }
}

function syncCaptions() {
    withDisabledObserver(() => {
        removeOrphanCaptions();
        upsertCaption();
    });
}

function startCaptionObserver() {
    if (window.__fsLightboxCaptionObserverStarted) {
        return;
    }

    const observer = new MutationObserver(() => {
        syncCaptions();
    });

    window.__fsLightboxCaptionObserver = observer;

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'src', 'caption'],
    });

    window.__fsLightboxCaptionObserverStarted = true;
}

function initFsLightbox(root = document) {
    cleanupInvalidHashTargets(root);

    if (typeof window.refreshFsLightbox === 'function') {
        window.refreshFsLightbox();
    }

    startCaptionObserver();

    window.setTimeout(syncCaptions, 100);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFsLightbox(), { once: true });
} else {
    initFsLightbox();
}

if (window.jQuery) {
    window.jQuery(document).on('ajaxComplete', () => initFsLightbox());
}

window.initFsLightbox = initFsLightbox;
